import './styles/InvoiceItem.scss';

import { Grid } from '@mui/material';
import { Invoice } from '@thro-types/jobmarket';

import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import {
  CompanyName,
  InvoiceId,
  KSNumber,
  StokNumber,
  CreatedAt,
  Amount,
  OfferId,
  OpenDMS
} from './invoiceData';

interface Props {
  invoice: Invoice;
  company?: boolean;
}

export const InvoiceItem: FunctionComponent<Props> = ({ invoice, company }: Props) => {
  const { t } = useTranslation();

  const renderItemBody = () => {
    if (company) {
      return [
        InvoiceId(invoice),
        KSNumber(invoice, t),
        StokNumber(invoice, t),
        CreatedAt(invoice),
        Amount(invoice),
        invoice.paid ? (
          <Grid item xs={3} className="invoice-item__cancellation-reason">
            {t(translations.pages.invoices.paidOn(), {
              date: new Date(invoice.modifiedAt).toLocaleDateString()
            })}
          </Grid>
        ) : (
          <Grid container item xs={3} justifyContent={'center'} alignContent={'center'}>
            {t(translations.common.none())}
          </Grid>
        )
      ];
    }

    return [
      InvoiceId(invoice),
      CompanyName(invoice),
      OfferId(invoice),
      KSNumber(invoice, t),
      StokNumber(invoice, t),
      CreatedAt(invoice, 1),
      Amount(invoice, 1),
      <Grid item xs={1} className="invoice-item__actions">
        <Grid container className="invoice-item__actions__group" justifyContent={'center'} gap={2}>
          {invoice.dmsLink ? (
            OpenDMS(invoice)
          ) : (
            <Grid container item xs={3} justifyContent={'center'} alignContent={'center'}>
              {t(translations.common.none())}
            </Grid>
          )}
        </Grid>
      </Grid>
    ];
  };

  return (
    <Grid
      container
      className={clsx('invoice-item', {
        'invoice-item--cancelled': invoice.cancelled
      })}
    >
      {renderItemBody()}
    </Grid>
  );
};
